import { Component, OnInit, NgZone, ViewChild, ViewContainerRef, TemplateRef, ComponentFactoryResolver, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { trigger,state,style,transition,animate,keyframes } from    '@angular/animations';
import {AspLoginService} from '../asp-login/asp-login.service';
import {AspCartService} from './asp-cart.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
// import {MatBottomSheet} from '@angular/material/bottom-sheet';
// import { AspShippingChargesBottomSheetComponent } from "../asp-shipping-charges-bottom-sheet/asp-shipping-charges-bottom-sheet.component";
import { AspShippingChargesPopupComponent } from "../asp-shipping-charges-popup/asp-shipping-charges-popup.component";
import { AspCouponDiscountPopupComponent } from "../asp-coupon-discount-popup/asp-coupon-discount-popup.component";
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AspLoadingComponent } from '../asp-loading/asp-loading.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { GlobalVariable } from 'app/main/globals';
import { ActivatedRoute } from '@angular/router';
import { AspPaymentService } from '../asp-payment/asp-payment.service';

@Component({
  selector: 'app-asp-cart',
  templateUrl: './asp-cart.component.html',
  styleUrls: ['./asp-cart.component.scss'],
  animations: [
    trigger('shakeit', [
        state('shakestart', style({
            transform: 'scale(1)',
        })),
        state('shakeend', style({
            transform: 'scale(1)',
        })),
        transition('shakestart => shakeend', animate('1000ms ease-in',     keyframes([
          style({transform: 'translate3d(-1px, 0, 0)', offset: 0.1}),
          style({transform: 'translate3d(2px, 0, 0)', offset: 0.2}),
          style({transform: 'translate3d(-4px, 0, 0)', offset: 0.3}),
          style({transform: 'translate3d(4px, 0, 0)', offset: 0.4}),
          style({transform: 'translate3d(-4px, 0, 0)', offset: 0.5}),
          style({transform: 'translate3d(4px, 0, 0)', offset: 0.6}),
          style({transform: 'translate3d(-4px, 0, 0)', offset: 0.7}),
          style({transform: 'translate3d(2px, 0, 0)', offset: 0.8}),
          style({transform: 'translate3d(-1px, 0, 0)', offset: 0.9}),
        ]))),
  ])]
})

export class AspCartComponent implements OnInit, AfterViewInit {
  loading: boolean;  
  states = {};
  make: string = '';
  model: string = '';
  year: string = ''; 
  variant: string = '';
  makeImage:string = '';
  cartList = [];  
  cartCount = 0;
  cartSubTotal = 0;
  sparesDiscount = 0;
  cartDiscount= 0;
  cartGrandTotal = 0;
  shippingAddressId: any;
  newData = {};
  addedCart = [];
  spareSelectedGarageName: any;
  shippingChargesApplicable: any;
  shippingCharges: any;  
  vehicleType:any = localStorage.getItem('vehicleType');
  emptyImg:any = 'assets/images/no-cart.png';
  isShippingCharges:any;
  isMobile: boolean;
  avoidShippingCharges: any;
  grandAmount: any;
  fuelType: string;
  registrationNumber: string;
  make1: any;
  model1: string;
  year1: string;
  variant1: string;
  variantKey: any;
  showBottomSheet: boolean;
  hasMegaSavings: boolean;
  originalCartList: any[] = [];       
megaSavingsCartList: any[] = [];  
  megaDiscount=0;
  megaSubTotal=0;
  megaSavingsTotal = 0;
  oesData: any[] = [];
  originalSubTotal: number;
  originalGrandTotal: number;
  showSavingsBanner: boolean;
  garageName: string;
  showSharedWtemPopup = false;
  sharedCartKey: string = '';
   cartItemsDummy = [
    {
      name: 'Radiator Lower Grill',
      brand: 'Munbi Suzuki',
      partNumber: '71710M63M00-SNSK',
      price: 914.64,
      image: 'https://via.placeholder.com/60'
    },
    {
      name: 'Front Stabilizer Link',
      brand: 'Munbi Suzuki',
      partNumber: '42410M63M00',
      price: 524.50,
      image: 'https://via.placeholder.com/60'
    },
    {
      name: 'Front Brake Disc',
      brand: 'Munbi Suzuki',
      partNumber: '55311M79F00',
      price: 1575.2,
      image: 'https://via.placeholder.com/60'
    },
    {
      name: 'Front Fender - RH',
      brand: 'Munbi Suzuki',
      partNumber: '76011M79G00',
      price: 1352.4,
      image: 'https://via.placeholder.com/60'
    },
    {
      name: 'Rear Tail Lamp - RH',
      brand: 'Munbi Suzuki',
      partNumber: '35660M68P00',
      price: 1352.4,
      image: 'https://via.placeholder.com/60'
    }
  ];
cartItems: any[] = [];
  autoverseCredit: any;
  autoverseCreditAmt: any;
  redeemCart: string;
  walletAmount: any;

  constructor(
    private router: Router,    
    private zone: NgZone,
    public dialog: MatDialog,
    private aspLoginService: AspLoginService,
    private aspCartService: AspCartService,
    private toastr: ToastrService,    
    // private _bottomSheet: MatBottomSheet,
    private bottomSheet: MatBottomSheet,
    private resolver: ComponentFactoryResolver,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    private location: Location,  
    private aspLoadingService: AspLoadingService,
    private route: ActivatedRoute,
    private aspPaymentService: AspPaymentService,
  ) {
      this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    }); 
    this.states['shake'] = 'shakestart';
   }
   
  // ngOnInit(): void {
  //   this.getCart(); // load savings tab by default
  //   this.getMegaSave();
  //   this.selectTab("savings");
  //   this.cardeails();
  //   // this.loading = true;
  //   this.aspLoginService.checkLogin();
  //   this.make = localStorage.getItem('selectedMake');
  //   this.model = localStorage.getItem('selectedModel');
  //   this.year = localStorage.getItem('selectedYear');
  //   this.variant = localStorage.getItem('variant');
  //   this.garageName = localStorage.getItem('garageName');
  //   this.showSavingsBanner= true;

  //   if(this.make)
  //     this.makeImage = 'https://cube.getpitstop.com/assets/img/'+(this.make.toLowerCase()).replace(' ','')+'.png';
   
  //   this.isShippingCharges = localStorage.getItem("isShippingCharges");
  //   // this.getShippingCharges();
    
  //   localStorage.removeItem('megaSavingsPromptShown')
  //   const cartData = sessionStorage.getItem('cart'); // or replace with your actual key/service
  //   const hasItems = cartData && JSON.parse(cartData).length > 0;

  //   if(this.cartCount>0){
  //     this.router.navigate(['/cart']);
  //   } else {
  //     this.router.navigate(['/home']);
  //   }
  //     this.showSharedWtemPopup = true; 

    
  // }
ngOnInit(): void {
  this.redeemCart=localStorage.getItem("redeemCart");
  this.walletAmount=localStorage.getItem("walletBalance");
  // console.log("walletAmount", this.walletAmount)
  localStorage.removeItem('instantOrderPay');
  localStorage.removeItem('slotid');
  localStorage.removeItem('slotName');
  localStorage.removeItem('slotWarehouseName');
  this.aspLoadingService.show();
  this.getCart();
  this.getMegaSave();
  this.selectTab("savings");
  this.cardeails(); // Load cart list from session
  this.aspLoginService.checkLogin();

  this.make = localStorage.getItem('selectedMake');
  this.model = localStorage.getItem('selectedModel');
  this.year = localStorage.getItem('selectedYear');
  this.variant = localStorage.getItem('variant');
  this.garageName = localStorage.getItem('garageName');
  this.isShippingCharges = localStorage.getItem("isShippingCharges");
  this.showSavingsBanner = true;
  localStorage.removeItem('megaSavingsPromptShown');

  if (this.make) {
    this.makeImage = `https://cube.getpitstop.com/assets/img/${this.make.toLowerCase().replace(' ', '')}.png`;
  }

    this.showSharedWtemPopup = false;
  // ✅ Check shared cart link
  this.route.queryParams.subscribe(params => {
    const cartKey = params['cartKey'];
   
    if (this.cartCount==0) {
        this.router.navigate(['/home'], {
            queryParams: {
                cartKey: cartKey,
            }
        });
              this.aspLoadingService.hide(); 
    }else{
      if (cartKey) {
              this.aspLoadingService.show();

        this.sharedCartKey = cartKey; // Save globally for payload

        this.aspCartService.getCartData(cartKey).subscribe(
          (response: any) => {
            this.aspLoadingService.hide();
            const items = response?.data?.items || [];

            this.cartItems = items;

            // Optional: Save first item to session cart
            if (items.length > 0) {
                        this.showSharedWtemPopup = true;
                this.cartItems = items; 
              }
            this.aspLoadingService.hide();
          },
          (error) => {
            console.error('❌ Error fetching shared cart data:', error);
            this.aspLoadingService.hide();

          }
        );
      }
    }
    
  });
  //  console.log("this.cartCount",this.cartCount);
   this.getWalletData()
   this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
      // console.log('✅ NavigationEnd detected in CartComponent. Reloading cart...');
      this.getCart();
          }
  });

}


  @ViewChild('dynamicContainers', { read: ViewContainerRef }) containers!: ViewContainerRef;

  @ViewChild('bottomSheetTemplate') bottomSheetTemplate!: TemplateRef<any>;


  ngAfterViewInit() {
    this.loadingMsg();
    this.cdr.detectChanges();
  
  }
//  cardeails(){
//   let data = JSON.parse(localStorage.getItem('addedCart'));
  
//   // Initialize the flag to check if all variantKeys are the same
//   let allVariantKeysAreEqual = true;
//   let firstVariantKey: string = '';
  
//   data.forEach(cart => {
//     Object.entries(cart).forEach(([key, cartitem]) => {
      
//       // Check if the variantKey is the same as the first one
//       if (firstVariantKey === '') {
//         firstVariantKey = cartitem['variantKey'];
//       } else if (firstVariantKey !== cartitem['variantKey']) {
//         allVariantKeysAreEqual = false;
//       }
  
//       if (allVariantKeysAreEqual) {
//         this.make1 = cartitem['selectedMake'];
//         this.model1 = cartitem['selectedModel'];
//         this.year1 = cartitem['selectedYear'];
//         this.variant1 = cartitem['variant'];
//         this.fuelType = cartitem['selectedFuel'];
//         this.registrationNumber = cartitem['registrationNumber'];
//         this.variantKey = cartitem['variantKey'];
//       } else {
//         // If variantKey is different, reset values
//         this.make1 = '';
//         this.model1 = '';
//         this.year1 = '';
//         this.variant1 = '';
//         this.fuelType = '';
//         this.registrationNumber ='';
//       }
//     });
//   });
// }
cardeails() {
  let dataRaw;
  if(this.redeemCart=='true'){
    dataRaw = localStorage.getItem('addedRedeem');
  }else{
    dataRaw = localStorage.getItem('addedCart');
  }
  if (!dataRaw) {
    console.warn('No addedCart data found in sessionStorage.');
    this.cartList = [];
    return;
  }

  let data: any[] = [];

  try {
    data = JSON.parse(dataRaw);
  } catch (err) {
    console.error('Error parsing addedCart from sessionStorage:', err);
    this.cartList = [];
    return;
  }

  // Convert nested object structure into flat cart list
  this.cartList = [];
  let allVariantKeysAreEqual = true;
  let firstVariantKey = '';

  data.forEach(cart => {
    Object.entries(cart).forEach(([key, cartitem]: [string, any]) => {
      // Push each cart item to cartList
      this.cartList.push(cartitem);

      if (firstVariantKey === '') {
        firstVariantKey = cartitem.variantKey;
      } else if (firstVariantKey !== cartitem.variantKey) {
        allVariantKeysAreEqual = false;
      }

      if (allVariantKeysAreEqual) {
        this.make1 = cartitem.selectedMake;
        this.model1 = cartitem.selectedModel;
        this.year1 = cartitem.selectedYear;
        this.variant1 = cartitem.variant;
        this.fuelType = cartitem.selectedFuel;
        this.registrationNumber = cartitem.registrationNumber;
        this.variantKey = cartitem.variantKey;
      } else {
        this.make1 = '';
        this.model1 = '';
        this.year1 = '';
        this.variant1 = '';
        this.fuelType = '';
        this.registrationNumber = '';
      }
    });
  });
}



  loadingMsg() {
    
    const factory = this.resolver.resolveComponentFactory(AspLoadingComponent);
    
   
  
    if (this.containers) {
      const componentRef = this.containers.createComponent(factory);
      
  
      const componentBInstance = componentRef.instance as AspLoadingComponent;
      componentBInstance.getLoadingMsg();
    } else {
      console.error('containers is undefined');
    }
  }
  
  scroll(el: HTMLElement) {
    el.scrollIntoView();
    this.shakeMe('shake');
  }

  shakeMe(stateVar: string) {
    this.states[stateVar] = (this.states[stateVar] === 'shakestart' ? 'shakeend' : 'shakestart');
  }

  shakeEnd(stateVar: string, event) {
  this.states[stateVar] = 'shakeend';
  }
  
removeItem(count, itemKey) {
  // console.log("removeItem", itemKey);

  const countval = count - 1;
  let dataRaw;
if(this.redeemCart=='true'){
    dataRaw =  JSON.parse(localStorage.getItem('addedRedeem'));
  }else{
    dataRaw =  JSON.parse(localStorage.getItem('addedCart'));
  }
  let savingsData =dataRaw?.[0] || {};

  // update mega
  let targetMegaItem = this.megaSavingsCartList.find(p => p.keyOem === itemKey);

  if (countval > 0) {
    // update both
    if (savingsData[itemKey]) {
      savingsData[itemKey].cart_qty = countval;
    }

    if (targetMegaItem) {
      targetMegaItem.cart_qty = countval;
    }
  } else {
    // remove if 1
    if (savingsData[itemKey]) {
      delete savingsData[itemKey];
    }
    if (targetMegaItem) {
      this.megaSavingsCartList = this.megaSavingsCartList.filter(p => p.keyOem !== itemKey);
    }
    this.toastr.error((targetMegaItem?.name || savingsData[itemKey]?.name || 'Item') + ' removed from cart', 'Cart Item');
  }

  // save
  this.addedCart[0] = savingsData;
  
  if(this.redeemCart=='true'){
    localStorage.setItem('addedRedeem', JSON.stringify(this.addedCart));
  }else{
    localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
  }
  

  // recalc
  this.megaSubTotal = 0;
  this.megaDiscount = 0;
  this.megaSavingsCartList.forEach(cart => {
    this.megaSubTotal += cart.mrp * cart.cart_qty;
    this.megaDiscount += cart.discount * cart.cart_qty;
  });
  this.megaSavingsTotal = this.megaSubTotal - this.megaDiscount;

  this.originalSubTotal = 0;
  this.cartDiscount = 0;
  
      this.originalCartList.forEach(cart => {
        this.originalSubTotal += (cart['mrp'] * cart['cart_qty']);
        this.cartDiscount += (cart['discount'] * cart['cart_qty']);
      });

  // update view
  if (this.selectedTab === 'savings') {
    this.getCart();
    this.updateCartView('savings');
  } else {
    this.updateCartView('mega-savings');
  }

  // this.cardeails();
}

addItem(count, itemKey) {
  // console.log("addItem", itemKey);

  const countval = count + 1;

  // get savings data
  let dataRaw;
  if(this.redeemCart=='true'){
    dataRaw =  JSON.parse(localStorage.getItem('addedRedeem'));
  }else{
    dataRaw =  JSON.parse(localStorage.getItem('addedCart'));
  }
  let savingsData = dataRaw?.[0] || {};

  // update mega-savings memory cart
  let targetMegaItem = this.megaSavingsCartList.find(p => p.keyOem === itemKey);

  if (targetMegaItem) {
    targetMegaItem.cart_qty = countval;
  }

  // update savings
  if (savingsData[itemKey]) {
    savingsData[itemKey].cart_qty = countval;
  }

  this.addedCart[0] = savingsData;
    if(this.redeemCart=='true'){
    localStorage.setItem('addedRedeem', JSON.stringify(this.addedCart));
  }else{
    localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
  }

  // recalculate mega
  this.megaSubTotal = 0;
  this.megaDiscount = 0;
  this.megaSavingsCartList.forEach(cart => {
    this.megaSubTotal += cart.mrp * cart.cart_qty;
    this.megaDiscount += cart.discount * cart.cart_qty;
  });
  this.megaSavingsTotal = this.megaSubTotal - this.megaDiscount;

  // recalculate savings
  this.originalSubTotal = 0;
  this.cartDiscount = 0;
  this.originalCartList.forEach(cart => {
  this.originalSubTotal += (cart['mrp'] * cart['cart_qty']);
  this.cartDiscount += (cart['discount'] * cart['cart_qty']);
});
  this.originalGrandTotal = this.originalSubTotal - this.cartDiscount;

  // update only current tab
  if (this.selectedTab === 'savings') {
    this.getCart();
    this.updateCartView('savings');
  } else {
    this.updateCartView('mega-savings');
  }

  // this.cardeails();
}


  getCart(){
      let dataRaw;
  if(this.redeemCart=='true'){
    dataRaw =  JSON.parse(localStorage.getItem('addedRedeem'));
  }else{
    dataRaw =  JSON.parse(localStorage.getItem('addedCart'));
  }
    if(dataRaw){    
      let cartData;  
      this.cartList = [];
      this.cartCount = 0;
      this.cartSubTotal = 0;
      this.sparesDiscount = 0;
      this.cartDiscount= 0;
      cartData = dataRaw;
      Object.values(cartData[0]).forEach(cart => { 
        this.cartCount += cart['cart_qty'];
        
        
        this.cartSubTotal += (cart['mrp']*cart['cart_qty']);
        this.sparesDiscount += (cart['discount']*cart['cart_qty']);
        this.cartList.push(cart);
      });
      
      this.originalCartList = this.cartList;
      this.updateCartView('savings');
      // if(this.sparesDiscount>0){
      //   this.cartGrandTotal = (this.cartSubTotal - this.sparesDiscount);
      // }else{
      //   this.cartGrandTotal = this.cartSubTotal;
      // }

      // if(this.isShippingCharges=='true'){
      //   this.getShippingCharges();
      // }
if(this.redeemCart !=='true'){
      if(!this.isMobile){
        // console.log("cartcount of if condition of web------{}",this.cartCount);
        if(this.cartCount>0){
          (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = ''+this.cartCount+' items <div class="right-amount-carts">₹'+this.cartGrandTotal.toFixed(2)+'</div>';
        }else{
          
          (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'Empty';
        }
      }else{
        // console.log("cartcount of else condition of web------{}",this.cartCount);
        if(this.cartCount>0){
          (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '<div class="cart_count">'+this.cartCount+'</div>';
        }else{
          (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '';
        }
      }
    }
      // this.getShippingCharges()
      
    }
  }

  deleteItem(item) {
  this.newData = {};
  let cartData;

    // Savings tab uses sessionStorage
  if(this.redeemCart=='true'){
    cartData =  JSON.parse(localStorage.getItem('addedRedeem'));
  }else{
    cartData =  JSON.parse(localStorage.getItem('addedCart'));
  }
    Object.values(cartData[0]).forEach(cart => {
      if (cart['key'] !== item) {
        this.newData[cart['key']] = cart;
      }
    });

    this.addedCart[0] = this.newData;
     if(this.redeemCart=='true'){
    localStorage.setItem('addedRedeem', JSON.stringify(this.addedCart));
  }else{
    localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
  }
    this.getCart();
    this.megaSavingsCartList = this.megaSavingsCartList.filter(p => p.key !== item);

}


  addMore(){
    if(this.redeemCart=='true'){
      this.router.navigate(['redeem']);
    }
    else{
    this.router.navigate(['spare-parts-list']);
    }
  }

 payment(): void {
  this.getMegaSavings();
  this.updateCartView('savings');
  const alreadyShown = localStorage.getItem('megaSavingsPromptShown');
  const garageKey = localStorage.getItem('garageKey');
  const cartGrand = this.megaSavingsTotal;

  // Step 1: Select cart list based on selectedTab
  const cartList = this.selectedTab === 'savings' ? this.originalCartList : this.megaSavingsCartList;

  // Step 2: Transform to key-value object format
  const cartObject: { [key: string]: any } = {};
  cartList.forEach(item => {
    if (item.key) {
      cartObject[item.key] = item;
    }
  });

  // Step 3: Store in sessionStorage in correct format (array with one object inside)
  sessionStorage.setItem('orderData', JSON.stringify([cartObject]));

  // Step 4: Get shipping charges
  this.aspCartService.getShippingCharges(cartGrand, garageKey).subscribe(result => {
    const res = JSON.parse(JSON.stringify(result)); 
    if (res.code === 200) {
      this.shippingCharges = res.data.shippingCharges;
      this.grandAmount = res.data.cartValue;
      this.megaSavingsTotal = this.grandAmount + this.shippingCharges;
    }
  });

  // Step 5: Show bottom sheet or go to payment
  if (this.selectedTab === 'savings' && !alreadyShown && this.hasMegaSavings) {
    this.showBottomSheet = true;
    localStorage.setItem('megaSavingsPromptShown', 'true');
  } else {
    this.goToPayment();
  }
}


  switchToMegaSavings(): void {
    this.selectTab('mega-savings');
    this.showBottomSheet = false;
    this.showSavingsBanner=false;
    // this.goToPayment();
    
  }

  closeSheet(): void {
    this.showBottomSheet = false;
    this.goToPayment();
  }

  goToPayment(): void {
    if(this.redeemCart=='true'){
      this.router.navigate(['payment']);
    }else{
      this.router.navigate(['slot']);
    }
  }
  // Shipping charges
  getShippingCharges(){    
    // this.loading = true; 
    let garageKey = localStorage.getItem('garageKey');
    let cartData;
     if(this.redeemCart=='true'){
              cartData = this.cartSubTotal;
            }else{
              cartData =  this.cartGrandTotal;
            }
    this.aspCartService.getShippingCharges(cartData, garageKey).subscribe(
      result => {
        let res = JSON.parse(JSON.stringify(result)); 
        if(res.code==200){
          // this.loading = false; 
          this.shippingChargesApplicable = res.data.shippingChargesApplicable;
          this.shippingCharges = res.data.shippingCharges;
          this.avoidShippingCharges = res.data.avoidShippingCharges;
          this.grandAmount= res.data.cartValue;
          this.cartGrandTotal = this.grandAmount+this.shippingCharges;
          let cartData;
            if(this.redeemCart=='true'){
              cartData =  JSON.parse(localStorage.getItem('addedRedeem')|| '[]');
             
            }else{
              cartData =  JSON.parse(localStorage.getItem('addedCart')|| '[]');
            }

          let itemCount = 0;
          if (cartData.length > 0 && typeof cartData[0] === 'object') {
            itemCount = Object.keys(cartData[0]).length;
          }

if(this.redeemCart !=='true'){
  // console.log("itemitemCount-----",itemCount);
          if(!this.isMobile){
            if(this.cartCount>0){

              (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = ''+itemCount+' items <div class="right-amount-carts">₹'+this.cartGrandTotal.toFixed(2)+'</div>';
            }else{
              (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'Empty';
            }
          }else{
            if(this.cartCount>0){
              (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '<div class="cart_count">'+itemCount+'</div>';
            }else{
              (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '';
            }
          }  
        }
      } else {
        if(this.redeemCart !=='true'){
        if(!this.isMobile){
          if(this.cartCount>0){
            (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = ''+this.cartCount+' items <div class="right-amount-carts">₹'+this.cartGrandTotal.toFixed(2)+'</div>';
          }else{
            (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'Empty';
          }
        }else{
          if(this.cartCount>0){
            (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '<div class="cart_count">'+this.cartCount+'</div>';
          }else{
            (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '';
          }
        }
      }
      }
    }
  );
}

  // shippingChargesBottomSheet(){
  //   this._bottomSheet.open(AspShippingChargesBottomSheetComponent);
  // }

  shippingChargesPopup(){
    this.zone.run(() => {
      this.dialog.open(AspShippingChargesPopupComponent);
    });
  }

  couponDiscountPopup(){
    this.zone.run(() => {
      this.dialog.open(AspCouponDiscountPopupComponent);
    });
  }

  browseParts(){
    // if(this.make && this.model && this.year && this.variant)
    //   this.router.navigate(['spare-parts-list']);
    // else
      this.router.navigate(['home']);
  }

  openBottomSheet(): void {
    this.bottomSheet.open(this.bottomSheetTemplate,{
     panelClass: 'custom-bottom-sheet1'
    }
    );
  }

  closeBottomSheet(): void {
    if (this.bottomSheet) {
      this.bottomSheet.dismiss();
    }
  }
  goBack(): void {
    this.location.back();
  }
  selectedTab = 'savings';

selectTab(tab: string) {
  this.selectedTab = tab;

  if (tab === 'mega-savings') {
    this.showSavingsBanner=false;
    this.getMegaSavings();
    this.updateCartView('mega-savings');
  } else {
    this.getCart();
    this.updateCartView('savings');
  }
}
getMegaSave(){
  const garageKey = localStorage.getItem('garageKey');
  const partNumber = this.originalCartList.map(item => item.partNumber).join(',');
  this.aspLoadingService.show();
  this.aspCartService.getMegaSavings(garageKey, partNumber, '', '').subscribe(result => {
    this.aspLoadingService.hide();
    let res = JSON.parse(JSON.stringify(result)); 

    if (res.code === 200) {
      this.oesData = res.data;
      this.getMegaSavings();
    // this.updateCartView('mega-savings');
    this.updateCartView('savings');
    }
  },
  (error) => {
    this.aspLoadingService.hide();
    // console.error('Error fetching invoices:', error);
  });
}
getMegaSavings() {
  this.hasMegaSavings = false;
  // console.log("this.originalCartList", this.originalCartList);

  this.megaSavingsCartList = this.originalCartList.map(item => {
  const matchedOesArray = this.oesData[item.partNumber];

  if (matchedOesArray && matchedOesArray.length > 0) {
    // ✅ Find the item with the lowest sellingPrice
    const oesItemWithLowestPrice = matchedOesArray.reduce((minItem, currentItem) => {
      return currentItem.sellingPrice < minItem.sellingPrice ? currentItem : minItem;
    }, matchedOesArray[0]);

    if (oesItemWithLowestPrice.sellingPrice < item.sellingPrice) {
      this.hasMegaSavings = true;
      return {
        ...oesItemWithLowestPrice,
        cart_qty: item.cart_qty,
        keyOem: item.key // ✅ Include the original key
      };
    }
  }

  return {
    ...item,
    keyOem: item.key // ✅ Include the key even if no savings
  };
});


  // console.log("megaSavingsCartList", this.megaSavingsCartList);

  if (this.selectedTab === 'mega-savings') {
    this.updateCartView('mega-savings');
  }

  // this.getShippingCharges();
}

updateCartView(tab: string) {
  // Current tab cart list
  if (tab ==='mega-savings') {
    this.cartList = [...this.megaSavingsCartList];
  } else {
    this.cartList = [...this.originalCartList];
  }

  // Common totals for active tab
  this.cartGrandTotal=0;
  this.cartSubTotal = 0;
  this.sparesDiscount = 0;

  this.cartList.forEach(cart => {
    this.cartSubTotal += (cart['mrp'] * cart['cart_qty']);
    this.sparesDiscount += (cart['discount'] * cart['cart_qty']);
  });

  this.cartGrandTotal = this.cartSubTotal - this.sparesDiscount;
this.getShippingCharges();
  // --- Separate totals for each list ---

  // Mega Savings Totals
  this.megaSubTotal = 0;
  this.megaDiscount = 0;

  this.megaSavingsCartList.forEach(cart => {
    this.megaSubTotal += (cart['mrp'] * cart['cart_qty']);
    this.megaDiscount += (cart['discount'] * cart['cart_qty']);
  });

  this.megaSavingsTotal = this.megaSubTotal - this.megaDiscount;

  // Original (Savings) Totalsthis.cartDiscount += (cart['discount']*cart['cart_qty']);
  this.originalSubTotal = 0;
  this.cartDiscount = 0;

  this.originalCartList.forEach(cart => {
    this.originalSubTotal += (cart['mrp'] * cart['cart_qty']);
    this.cartDiscount += (cart['discount'] * cart['cart_qty']);
  });

  this.originalGrandTotal = this.originalSubTotal - this.cartDiscount;

  // Optional: log the discount difference
  
}

closeBanner(){
  this.showSavingsBanner=false;
}
shareCartViaWhatsApp() {
  const garageName = (localStorage.getItem('spareSelectedGarageName') || 'Our Garage').trim();
  const vehicleName = localStorage.getItem('selectedVehicleName') || 'Vehicle';
  const garageKey = localStorage.getItem('garageKey') || '';
  const userKey = localStorage.getItem('spareUserKey') || '';
  const registrationNumber = localStorage.getItem('selectedRegistrationNumber') || '';

  if (!this.cartList || this.cartList.length === 0) {
    console.warn('Cart is empty.');
    return;
  }
// console.log("rtyuiuytrtyui==ergetrgtgrthrtrtrrgt",this.cartList)
// console.log("psrtkey",this.cartList['partKey'])
  const payload = this.cartList.map(item => ({
    partKey: item.part_key || item.partKey || item.key || '',
    rowKey: item.row_key || item.rowKey || '',
    partNumber: item.partNumber || '',
    name: item.name || '',
    brandKey: item.brandKey || '',
    brandName: item.brandName || '',
    brandDescription: item.brandDescription || '',
    cartQty: item.cart_qty || item.cartQty || 1,
    category: item.category || '',
    customerBoughtCount: item.customerBoughtCount || 0,
    deliveryStatus: item.deliveryStatus || '',
    deliveryTime: item.deliveryTime || '',
    description: item.description || null,
    discount: item.discount || 0,
    discountType: item.discountType || null,
    hsn: item.hsn || '',
    imageUrl: item.imageUrl || '',
    itemId: item.itemId || '',
    garageCount: item.garageCount || 0,
    orderedCount: item.orderedCount || 0,
    previouslyBought: item.previouslyBought || false,
    mrp: item.mrp || 0,
    partType: item.partType || '',
    plannedSku: item.plannedSku || 0,
    quantity: item.quantity || 0,
    registrationNumber: registrationNumber,
    selectedFuel: item.selectedFuel || '',
    selectedMake: item.selectedMake || '',
    selectedModel: item.selectedModel || '',
    selectedYear: item.selectedYear || '',
    sellingPrice: item.sellingPrice || 0,
    soldQuantity: item.soldQuantity || 0,
    discountAmount: item.discountAmount || 0,
    subCategory: item.subCategory || '',
    tag: item.tag || '',
    unit: item.unit || 0,
    unitType: item.unitType || '',
    variant: item.variant || '',
    variantKey: item.variantKey || '',
    garageKey: garageKey,
    userKey: userKey
  }));
  // console.log("payload",payload)
  this.aspLoadingService.show();
this.aspCartService.createCart(payload).subscribe(
    (response: any) => {
      this.aspLoadingService.hide();

      const cartKey = response?.data?.[0]?.cartKey;
      if (!cartKey) {
        console.error('Cart key missing in response');
        return;
      }
      
  const shareCartUrl = `${GlobalVariable.AUTOVERSE_WEB}/cart?cartKey=${cartKey}`;

      const message =
        // `Hello ${garageName}! 👋\n\n` +
        // `🚗🔧 Find the Perfect ${vehicleName} Parts List!\n\n` +
        // `Upgrade your customer's rides with precision.\n\n` +
        // `Tap to explore now 👉 🛠\n${shareCartUrl}`;
         `*📱 Order directly and Win Extra Discount! 🎉*\n\n` +
        `Hi ${garageName} \n\n` +
        `*🌟 Don't Forget Your Cart!*\n\n` +
        `*Spares Discount = ₹ ${this.sparesDiscount.toFixed(2)}*\n\n` +
        `Complete your purchase now and enjoy the savings!\n\n` +
        `Click here to view your cart page\n${shareCartUrl}`;

      const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
    },
    error => {
      console.error('Error creating cart:', error);
    }
  );

}


closeSharedWtemPopup() {
  const cartKey = this.sharedCartKey;
  const payload = { cartKey };

  this.aspCartService.updateCartDetails(payload).subscribe(
    (response: any) => {
      // console.log('✅ Cart updated successfully on cancel:', response);
    },
    error => {
      console.error('❌ Failed to update cart on cancel:', error);
    }
  );

  this.showSharedWtemPopup = false;
}


// addSharedCartToLocalCart() {
//   this.aspLoadingService.show();
//   this.showSharedWtemPopup = true;

//   const cartKey = this.sharedCartKey

//   if (this.cartItems && this.cartItems.length > 0) {
//     const structuredCartObject = {};
//     console.log("this.cartItems----",this.cartItems);
//     this.cartItems.forEach(item => {
//        const key = item.partKey && item.partKey.trim() ? item.partKey : item.itemId;

//       structuredCartObject[key] = {
//         key: key,
//         partNumber: item.partNumber,
//         name: item.name,
//         brand: {
//           key: item.brandKey || '',
//           name: item.brandName || '',
//           description: item.brandDescription || '',
//         },
//         cart_qty: item.cartQty || 1,
//         category: item.category,
//         customerBoughtCount: item.customerBoughtCount,
//         deliveryStatus: item.deliveryStatus,
//         deliveryTime: item.deliveryTime,
//         description: item.description,
//         discount: item.discount,
//         discountType: item.discountType,
//         hsn: item.hsn,
//         imageUrl: item.imageUrl,
//         itemId: item.itemId,
//         itemSummary: {
//           partNumber: item.partNumber,
//           previouslyBought: item.previouslyBought,
//           orderedCount: item.orderedCount,
//           garageCount: item.garageCount
//         },
//         garageCount: item.garageCount,
//         orderedCount: item.orderedCount,
//         previouslyBought: item.previouslyBought,
//         mrp: item.mrp,
//         partType: item.partType,
//         plannedSku: item.plannedSku,
//         quantity: item.quantity,
//         registrationNumber: item.registrationNumber,
//         rowKey: item.rowKey,
//         selectedFuel: item.selectedFuel,
//         selectedMake: item.selectedMake,
//         selectedModel: item.selectedModel,
//         selectedYear: item.selectedYear,
//         sellingPrice: item.sellingPrice,
//         soldQuantity: item.soldQuantity,
//         spareStocks: {
//           partNumber: item.partNumber,
//           quantity: item.quantity,
//           mrp: item.mrp,
//           sellingPrice: item.sellingPrice,
//           discountType: item.discountType,
//           discountAmount: item.discount
//         },
//         discountAmount: item.discount,
//         subCategory: item.subCategory,
//         tag: item.tag,
//         unit: item.unit,
//         unitType: item.unitType,
//         variant: item.variant,
//         variantKey: item.variantKey
//       };
//     });

// const structuredCartArray = Object.values(structuredCartObject); 
// this.cartList.push(...structuredCartArray); 
// localStorage.setItem('addedCart', JSON.stringify(this.cartList));
//   }

//   // Update cart details via API
//   const payload = { cartKey };

//   this.aspCartService.updateCartDetails(payload).subscribe(
//     (response: any) => {
//       console.log('✅ Cart updated successfully:', response);
//       this.aspLoadingService.hide();
//       this.showSharedWtemPopup = false;
//       this.router.navigate(['/cart']);
//     },
//     error => {
//       console.error('❌ Failed to update cart:', error);
//       this.aspLoadingService.hide();
//     }
//   );
// }



  getWalletData() {
    const garageKey = localStorage.getItem('garageKey');
    const userKey = localStorage.getItem('spareUserKey');

    this.aspPaymentService.getWallet(garageKey,userKey).subscribe(
      res => {
        this.autoverseCredit=res['data'].autoverseCredit.isAutoverseCredit;
        this.autoverseCreditAmt= res['data'].autoverseCredit.availableCreditAmount;
      });
    }

}
  